import React from "react";

export default function TraderListIcon() {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="10"
          cy="13.7498"
          rx="5"
          ry="2.08333"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <ellipse
          cx="10"
          cy="6.6665"
          rx="2.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M5.62695 10.9219C4.67308 11.3887 3.95778 12.0045 3.59668 12.7061C3.44179 12.7511 3.29754 12.799 3.16602 12.8516C2.84158 12.9813 2.62882 13.117 2.50977 13.2295C2.45719 13.2792 2.43245 13.3138 2.42188 13.333C2.43219 13.352 2.45638 13.387 2.50977 13.4375C2.6288 13.55 2.84153 13.6856 3.16602 13.8154C3.22099 13.8374 3.27869 13.8572 3.33789 13.8779C3.37582 14.5154 3.69707 15.1115 4.23242 15.6299C3.63004 15.538 3.07784 15.3967 2.6084 15.209C2.17938 15.0374 1.78207 14.8134 1.47949 14.5273C1.2133 14.2756 0.98227 13.9354 0.928711 13.5176L0.916992 13.334L0.928711 13.1494C0.982318 12.7317 1.21334 12.3914 1.47949 12.1396C1.78201 11.8537 2.17951 11.6306 2.6084 11.459C3.42227 11.1335 4.48387 10.9428 5.62695 10.9219Z"
          fill="currentColor"
        />
        <path
          d="M14.3729 10.9219C15.5162 10.9427 16.5775 11.1334 17.3915 11.459C17.8207 11.6307 18.2187 11.8535 18.5214 12.1396C18.8256 12.4274 19.0829 12.8312 19.0829 13.334C19.0827 13.8365 18.8255 14.2397 18.5214 14.5273C18.2187 14.8135 17.8207 15.0373 17.3915 15.209C16.9217 15.3969 16.3692 15.538 15.7665 15.6299C16.3022 15.1114 16.623 14.5156 16.661 13.8779C16.7205 13.8571 16.7786 13.8375 16.8339 13.8154C17.1583 13.6857 17.3711 13.55 17.4901 13.4375C17.5431 13.3874 17.5666 13.3521 17.577 13.333C17.5663 13.3137 17.5423 13.2788 17.4901 13.2295C17.371 13.117 17.1582 12.9813 16.8339 12.8516C16.7021 12.7989 16.5574 12.7511 16.4022 12.7061C16.041 12.0046 15.3266 11.3886 14.3729 10.9219Z"
          fill="currentColor"
        />
        <path
          d="M14.1667 5.08301C15.5011 5.08318 16.5825 6.16557 16.5827 7.5C16.5825 8.83443 15.5011 9.91584 14.1667 9.91602C13.7286 9.91596 13.3189 9.79758 12.9645 9.59375C13.3184 9.23534 13.6071 8.81298 13.8132 8.3457C13.922 8.39121 14.0414 8.41597 14.1667 8.41602C14.6727 8.41584 15.0825 8.006 15.0827 7.5C15.0825 6.994 14.6727 6.58318 14.1667 6.58301H14.1638C14.1535 6.06075 14.0475 5.56268 13.862 5.10449C13.9619 5.0919 14.0634 5.08302 14.1667 5.08301Z"
          fill="currentColor"
        />
        <path
          d="M5.83398 5.08301C5.93657 5.08303 6.0375 5.09108 6.13672 5.10352C5.9511 5.56182 5.84525 6.06059 5.83496 6.58301H5.83398C5.32783 6.58301 4.91717 6.99389 4.91699 7.5C4.91717 8.00611 5.32783 8.41602 5.83398 8.41602C5.95896 8.41593 6.07801 8.39105 6.18652 8.3457C6.39255 8.81296 6.68129 9.23534 7.03516 9.59375C6.68107 9.7974 6.27182 9.9159 5.83398 9.91602C4.4994 9.91602 3.41717 8.83454 3.41699 7.5C3.41717 6.16546 4.4994 5.08301 5.83398 5.08301Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
}
